/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BillingFrequency = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type BillingFrequency = typeof BillingFrequency[keyof typeof BillingFrequency];


export function BillingFrequencyFromJSON(json: any): BillingFrequency {
    return BillingFrequencyFromJSONTyped(json, false);
}

export function BillingFrequencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingFrequency {
    return json as BillingFrequency;
}

export function BillingFrequencyToJSON(value?: BillingFrequency | null): any {
    return value as any;
}

